import * as React from 'react';
const useBaseLayer = (map, allLayers) => {
    // When map base layer changes, update map style
    const [mapLayer, setMapLayer] = React.useState(allLayers[0]);
    const mapStyle = mapLayer.style;
    React.useEffect(() => {
        if (!map)
            return;
        map.setStyle(mapStyle);
    }, [map, mapStyle]);
    // when style loads or changes increment some counter, it's just technical variable for updating layers
    const [styleChangedNum, setStyleChangedNum] = React.useState(0);
    React.useEffect(() => {
        if (!map)
            return;
        const updateStyleCounter = () => {
            setStyleChangedNum(prev => prev + 1);
        };
        map.on('style.load', updateStyleCounter);
        return () => {
            setStyleChangedNum(0);
            map.off('style.load', updateStyleCounter);
        };
    }, [map]);
    return {
        baseLayer: mapLayer,
        setBaseLayer: setMapLayer,
        baseLayerChangedNum: styleChangedNum,
    };
};
export default useBaseLayer;
